import axios from "../axiosConfig";

class Routes {

 
    login= (val) => {
        let data = axios.post("/api/login", val);
        return data;
    };
    Register= (val) => {
        let data = axios.post("/api/register", val);
        return data;
    };

}



export default new Routes();